import { SimpleFileLink } from '@texas/api/endpoints/filesApi';
import {
  ComplianceDocumentKind,
  ComplianceDocumentType,
} from './complianceDocumentDefinitionsApi';
import { httpClient } from '@texas/api/httpClient/httpClient';

export interface MaterialComplianceDocument {
  complianceDocumentDefinitionId: number;
  name: string;
  description: string;
  kind: ComplianceDocumentKind;
  type: ComplianceDocumentType;
  archived: string | null;
  logo: SimpleFileLink | null;
  added: string;
}

export const materialComplianceDocumentsApi = {
  get: (materialId: number) =>
    httpClient.get<MaterialComplianceDocument[]>(
      `metadata/materials/${materialId}/compliance-documents`,
    ),
  assign: (materialId: number, definitionId: number) =>
    httpClient.put(
      `metadata/materials/${materialId}/compliance-documents/${definitionId}`,
    ),
  remove: (materialId: number, definitionId: number) =>
    httpClient.delete(
      `metadata/materials/${materialId}/compliance-documents/${definitionId}`,
    ),
};
